import type { ChatQuizInterviewSectionSettings } from "@repo/app-types/entities/interviewSection/settings";
import { useEffectEvent } from "@repo/ui/helpers/useEffectEvent";
import { type FC, useEffect } from "react";
import { QuestionsManager } from "../../../projects/recruitingQuestions/questionsManager.js";
import { useQuestionsStore } from "../../../projects/recruitingQuestions/questionsStore.js";

export interface ChatQuizInterviewSectionDefinitionSettingsProps {
  interviewSectionDefinitionId: string;
  settings: ChatQuizInterviewSectionSettings;
  onChange: (
    interviewSectionDefinitionId: string,
    newSettings: ChatQuizInterviewSectionSettings,
  ) => void;
}

export const ChatQuizInterviewSectionDefinitionSettings: FC<
  ChatQuizInterviewSectionDefinitionSettingsProps
> = (props) => {
  const [{ questions, hasMadeChanges }, onQuestionsChange] = useQuestionsStore(
    props.settings.questions || [],
  );

  const onBasicQuestionsChange = useEffectEvent(
    (newBasicQuestions: { question: string }[]) => {
      props.onChange(props.interviewSectionDefinitionId, {
        ...props.settings,
        questions: newBasicQuestions,
      });
    },
  );

  useEffect(() => {
    if (hasMadeChanges) {
      const basicQuestions = questions.map(({ question }) => ({ question }));
      onBasicQuestionsChange(basicQuestions);
    }
  }, [questions, hasMadeChanges]);

  return (
    <QuestionsManager
      questions={questions}
      onQuestionsChange={onQuestionsChange}
    />
  );
};
